import Documentation from "components/Documentation";

const DocumentationPage = () => {
  return <Documentation />;
};

export default DocumentationPage;
